import { ReactNode } from 'react';
import { LuLaptopMinimal } from 'react-icons/lu';
import { FaMobileAlt } from 'react-icons/fa';
import { FaWandMagicSparkles } from 'react-icons/fa6';

// Import testimonial assets
import img1 from '@/assets/img/testimonial/testimonial-logo-athomeservice.png';
import img2 from '@/assets/img/testimonial/testimonial-logo-vdw-cleaning-service.png';
import img3 from '@/assets/img/testimonial/testimonial-logo-axez.png';

interface IDienstan {
  icon: ReactNode;
  title: string;
  info: string;
}
export const dienstandData: IDienstan[] = [
  {
    icon: <LuLaptopMinimal size={60} />,
    title: 'Dashboard',
    info: 'Uw persoonlijke Dashboard biedt je een overzicht en efficiënte navigatie. Een overzicht van bv. alle vervangingen, prospects, verder te helpen klanten en natuurlijk veel meer, ...'
  },
  {
    icon: <FaMobileAlt size={45} />,
    title: 'Volledige Mobiele Toegang',
    info: 'Raadpleeg je personeelsplanning of je klantenlijst op weg vanop je mobiele telefoon of tablet-apparaat.Geformatteerd voor alle mobiele apparaten.'
  },
  {
    icon: <FaWandMagicSparkles size={45} />,
    title: 'Magisch Makkelijk',
    info: 'Solvere is een management software voor de 21e eeuw. Het is ongelooflijk eenvoudig te gebruiken en beschikt over een dynamische interface met intuïtieve drag-and-drop acties.'
  }
];

// Testimonial Data

export interface IDienstanTestimonial {
  name: string;
  company: string;
  comment: string;
  logo: string;
  position: 'left' | 'right';
}

export const dienstanTestimonials: IDienstanTestimonial[] = [
  {
    name: 'Van De Weerdhof Gijsberta',
    company: 'At Home Service',
    comment:
      'Het heeft me gered van de vele uren die ik vroeger deed met de hand.. en de steun is erg behulpzaam geweest bij het overschakelen. Geweldig product en goede ondersteuning.',
    logo: img1,
    position: 'left'
  },
  {
    name: 'Nancy Van De Weyer',
    company: 'VDW Cleaning Service',
    comment:
      'Bedankt voor de eenvoudige krachtige tool. Dankzij jullie hebben we dan weer meer mogelijkheden om klantgerichter te werken in de toekomst.',
    logo: img2,
    position: 'right'
  },
  {
    name: 'Axez interim',
    company: '',
    comment:
      'Sterk punt van Solvere vinden wij hun efficiëntie. Zij kennen de markt, en onze behoeften. Hun tarieven zijn scherp en dat biedt ons een groot kostenvoordeel. Waarvan acte!',
    logo: img3,
    position: 'left'
  }
];
